import { render, staticRenderFns } from "./SLTransactions2.vue?vue&type=template&id=0c6efb0b&"
import script from "./SLTransactions2.vue?vue&type=script&lang=js&"
export * from "./SLTransactions2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports